// src/components/UserTable.jsx
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  CircularProgress,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";

const CompactTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.5), // Adjust padding to make it more compact
  fontSize: "0.875rem", // Adjust font size if needed
}));

const FirstColumnTableCell = styled(CompactTableCell)(({ theme }) => ({
  paddingLeft: theme.spacing(1), // Add extra padding to the left
}));

const UserTable = ({
  data,
  isLoading,
  isError,
  error,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  // Sort users by name in ascending order
  const sortedUsers =
    data?.users
      ?.slice()
      .sort((a, b) =>
        `${a.givenName} ${a.familyName}`.localeCompare(
          `${b.givenName} ${b.familyName}`
        )
      ) || [];

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <FirstColumnTableCell>#</FirstColumnTableCell>
              <CompactTableCell>Name</CompactTableCell>
              <CompactTableCell>Email</CompactTableCell>
              <CompactTableCell>Group</CompactTableCell>
              <CompactTableCell>Accessible Dashboards</CompactTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <CompactTableCell colSpan={5} align="center">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                  >
                    <CircularProgress />
                  </Box>
                </CompactTableCell>
              </TableRow>
            ) : isError ? (
              <TableRow>
                <CompactTableCell colSpan={5} align="center">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                  >
                    <div>Error: {error.message}</div>
                  </Box>
                </CompactTableCell>
              </TableRow>
            ) : (
              sortedUsers.map((user, index) => (
                <TableRow key={index}>
                  <FirstColumnTableCell>
                    {index + 1 + page * rowsPerPage}
                  </FirstColumnTableCell>
                  <CompactTableCell>{`${user.givenName} ${user.familyName}`}</CompactTableCell>
                  <CompactTableCell>{user.email}</CompactTableCell>
                  <CompactTableCell>
                    {user.groups.map(
                      (
                        group,
                        i // Display each group in a new line
                      ) => (
                        <div key={i}>{group}</div>
                      )
                    )}
                  </CompactTableCell>
                  <CompactTableCell>
                    {user.dashboards.map((dashboard, i) => (
                      <div key={i}>{dashboard}</div>
                    ))}
                  </CompactTableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {!isLoading && !isError && (
        <Box display="flex" justifyContent="flex-end" alignItems="center" p={2}>
          <TablePagination
            component="div"
            count={-1} // Unknown total count
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 20, 50]}
            labelDisplayedRows={({ from, to }) => `${from}-${to}`}
            nextIconButtonProps={{ disabled: Boolean(data.isLastPage) }}
          />
        </Box>
      )}
    </Paper>
  );
};

export default UserTable;
